"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Transition } from "@headlessui/react";
import { Fragment, useEffect, useMemo, useState } from "react";
import ReactCountryFlag from "react-country-flag";
import { StateType } from "@lib/hooks/use-toggle-state";
import { useParams, usePathname } from "next/navigation";
import { updateRegion } from "@lib/data/cart";
import { HttpTypes } from "@medusajs/types";
type CountryOption = {
  country: string;
  region: string;
  label: string;
};
type CountrySelectProps = {
  toggleState: StateType;
  regions: HttpTypes.StoreRegion[];
  countryCode: string;
};
const CountrySelect = t0 => {
  const $ = _c(33);
  const {
    toggleState,
    regions,
    countryCode
  } = t0;
  const [current, setCurrent] = useState(undefined);
  const {
    state,
    close
  } = toggleState;
  let t1;
  if ($[0] !== regions) {
    t1 = regions?.map(_temp).flat().sort(_temp2);
    $[0] = regions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  let t3;
  if ($[2] !== countryCode || $[3] !== options) {
    t2 = () => {
      if (countryCode) {
        const option = options?.find(o => o?.country === countryCode);
        setCurrent(option);
      }
    };
    t3 = [options, countryCode];
    $[2] = countryCode;
    $[3] = options;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== close) {
    t4 = option_0 => {
      updateRegion(option_0.country);
      close();
    };
    $[6] = close;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleChange = t4;
  const t = useTranslations("countries");
  let t5;
  if ($[8] !== countryCode || $[9] !== options) {
    t5 = countryCode ? options?.find(o_0 => o_0?.country === countryCode) : undefined;
    $[8] = countryCode;
    $[9] = options;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("Shipping to");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <span>{t6}:</span>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== current || $[16] !== t) {
    t8 = current && <span className="txt-compact-small flex items-center gap-x-2"><ReactCountryFlag svg={true} style={{
        width: "16px",
        height: "16px"
      }} countryCode={current.country ?? ""} />{t(current.label)}</span>;
    $[15] = current;
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <ListboxButton className="py-1 w-full"><div className="txt-compact-small flex items-start gap-x-2">{t7}{t8}</div></ListboxButton>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== options) {
    t10 = options?.map(_temp3);
    $[21] = options;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10) {
    t11 = <ListboxOptions className="absolute -bottom-[calc(100%-36px)] left-0 xsmall:left-auto xsmall:right-0 max-h-[442px] overflow-y-scroll z-[900] bg-white drop-shadow-md text-small-regular uppercase text-black no-scrollbar rounded-rounded w-full" static={true}>{t10}</ListboxOptions>;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== state || $[26] !== t11) {
    t12 = <div className="flex relative w-full min-w-[320px]"><Transition show={state} as={Fragment} leave="transition ease-in duration-150" leaveFrom="opacity-100" leaveTo="opacity-0">{t11}</Transition></div>;
    $[25] = state;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== handleChange || $[29] !== t12 || $[30] !== t5 || $[31] !== t9) {
    t13 = <div><Listbox as="span" onChange={handleChange} defaultValue={t5}>{t9}{t12}</Listbox></div>;
    $[28] = handleChange;
    $[29] = t12;
    $[30] = t5;
    $[31] = t9;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
};
export default CountrySelect;
function _temp(r) {
  return r.countries?.map(c => ({
    country: c.iso_2,
    region: r.id,
    label: c.display_name
  }));
}
function _temp2(a, b) {
  return (a?.label ?? "").localeCompare(b?.label ?? "");
}
function _temp3(o_1, index) {
  return <ListboxOption key={index} value={o_1} className="py-2 hover:bg-gray-200 px-3 cursor-pointer flex items-center gap-x-2"><ReactCountryFlag svg={true} style={{
      width: "16px",
      height: "16px"
    }} countryCode={o_1?.country ?? ""} />{" "}{o_1?.label}</ListboxOption>;
}